import { authHeader } from "../_core/auth-header";
import Config from "../_core/config";

export const emailService = {
  send,
  reciept,
  forgotPassword,
  changePassword,
};

function send(mail) {
  console.log(mail)
  const body = {
    email: mail.email,
    name: mail.name,
    subject: "Contact Us Inquiry",
    message: mail.message,
    phone: mail.phone,
  };
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(body),
  };

  return fetch(Config.api.basepath + `/custom/v1/send-email`, requestOptions)
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to send email');
    }
    return response.json();
    }
  )
  .then(response => {
    if (response.success) {
      return response
  } else {
      return { success: false, message: response };
  }
  })
}

function reciept(mail) {
  const body = {
    email: mail.email,
    name: mail.name,
    subject: mail.subject,
    message: mail.message,
    phone: mail.phone,
  };
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(body),
  };

  return fetch(Config.api.basepath + `/mail`, requestOptions).then(
    handleResponse
  );
}

function forgotPassword(email) {

    return fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
            action: 'forgot_password',
            email: email
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to send password reset email');
        }
        return response.json();
    })
    .then(data => {
        if (data.success) {
            return { success: true, message: 'Password reset email sent successfully' };
        } else {
            return { success: false, message: data.data };
        }
    })
    .catch(error => {
        console.error('Error sending password reset email:', error);
        return { success: false, message: 'An unexpected error occurred.' };
    });
}





// function changePassword({ password, token }) {
//   const requestOptions = {
//     method: "PUT",
//     headers: { ...authHeader(), resetToken: token },
//     body: JSON.stringify({ newPassword: password }),
//   };

//   return fetch(
//     Config.api.basepath + `/auth/password/update`,
//     requestOptions
//   ).then(handleResponse);
// }

// function changePassword(currentPassword, newPassword, confirmPassword) {
//     const baseUrl = window.location.origin;

//     const credentials = {
//         current_password: currentPassword,
//         new_password: newPassword,
//         confirm_password: confirmPassword
//     };

//     // Get nonce from cookie
//     const nonce = getCookie('wp_rest_nonce');

//     // Ensure nonce is available
//     if (!nonce) {
//         console.error('Nonce not found in cookie');
//         return Promise.reject({ success: false, message: 'Nonce not found. Please try logging in again.' });
//     }

//     // Include the nonce in the request headers
//     return fetch(`${baseUrl}/wp-json/custom/v1/change-password`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'X-WP-Nonce': nonce
//         },
//         body: JSON.stringify(credentials)
//     })
//     .then(response => response.json())
//     .then(data => {
//         if (data.success) {
//             // Return success message
//             return { success: true, message: data.message };
//         } else {
//             // Return error message
//             return { success: false, message: data.message || 'Failed to change password' };
//         }
//     })
//     .catch(error => {
//         console.error(error);
//         // Return error message
//         return { success: false, message: error.message || 'Failed to change password' };
//     });
// }

// // Function to retrieve nonce from cookie
// function getCookie(name) {
//     // Split cookie string and get all individual name=value pairs in an array
//     var cookieArr = document.cookie.split(";");
//     // Loop through the array elements
//     for (var i = 0; i < cookieArr.length; i++) {
//         var cookiePair = cookieArr[i].split("=");
//         /* Removing whitespace at the beginning of the cookie name
//             and compare it with the given string */
//         if (name == cookiePair[0].trim()) {
//             // Decode the cookie value and return
//             return decodeURIComponent(cookiePair[1]);
//         }
//     }
//     // Return null if not found
//     return null;
// }

function changePassword(oldPassword, newPassword, confirmPassword) {
    const baseUrl = window.location.origin;
    const token = localStorage.getItem('token');

    // console.log('Token:', token); // Debugging log

    if (!token) {
        // console.error('Token not found.');
        return Promise.reject(new Error('Token not found.'));
    }

    const decodedToken = customDecodeJWT(token);
    // console.log('Decoded Token:', decodedToken); // Debugging log

    if (!decodedToken || !decodedToken.exp) {
        console.error('Invalid token format or missing expiration.');
        return Promise.reject(new Error('Invalid token format or missing expiration.'));
    }

    const currentTimestamp = Math.floor(Date.now() / 1000);
    // console.log('Current Timestamp:', currentTimestamp);
    // console.log('Token Expiry:', decodedToken.exp);

    if (decodedToken.exp < currentTimestamp) {
        // console.error('Token expired.');
        return Promise.reject(new Error('Token expired.'));
    }

    const data = {
        current_password: oldPassword.oldPassword,
        new_password: oldPassword.newPassword,
        confirm_password: oldPassword.confirmPassword
    };


    return fetch(`${baseUrl}/wp-json/custom/v1/change-password`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to change password');
        }
        return response.json();
    })
    .then(data => {
        console.log(data.message); // Debugging log
        return data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

function customDecodeJWT(token) {
    const base64UrlPayload = token.split('.')[1];
    const payload = JSON.parse(atob(base64UrlPayload));
    return payload;
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error =
        (data && data.message) || (data && data.error) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}